"use client";

import { ImageWithFallback } from "@/components/ui/image-with-fallback";
import { cn } from "@/lib/utils";

export default function Poster({ event, className }: any) {
  if (event.image) {
    return (
      <div className={cn("rounded-xl overflow-hidden saturate-130", className)}>
        <ImageWithFallback
          src={event.image ? event.image : undefined}
          alt={event.name}
          className="flex object-cover w-full h-full "
        ></ImageWithFallback>
      </div>
    );
  } else {
    return <></>;
  }
}
